import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../../types/referrer/store';
import { setUserId, setUserPhoneNumber } from '../../../slices';
import {
  fetchCianApiSiteV1GetUserDataByRequest,
  type TCianApiSiteV1GetUserDataByRequestResponse,
} from '../../../repositories/monolith-python/cian-api/site/v1/get-user-data-by-request';

export const getUser = createAsyncThunk<void, undefined, IThunkApi>('user/getUser', async (_, _thunkApi) => {
  const {
    dispatch,
    extra: { httpApi, logger },
  } = _thunkApi;

  try {
    const res = (await fetchCianApiSiteV1GetUserDataByRequest({
      httpApi,
    })) as TCianApiSiteV1GetUserDataByRequestResponse;

    if (res.statusCode === 200) {
      const {
        data: { user },
      } = res.response;

      if (user) {
        const { userId } = user;
        dispatch(setUserId(userId));

        const { phones } = user;
        const { phone } = phones?.[0] || {};
        dispatch(setUserPhoneNumber(phone));

        return;
      }
    }
  } catch (e) {
    logger.debug('Ошибка загрузки листинга рефералов', {
      message: e.message,
      domain: e.domain,
    });

    dispatch(setUserId(undefined));
    dispatch(setUserPhoneNumber(undefined));
  }
});
